function accordionBlockWithDoc(container, collapsible) {

    var button  = container.find('._js-block-with-doc-btn'),
        accordionBody = container.find('.block-with-doc__body');


    button.on('click', function(){
        var accordion = $(this).parents('.js-accordion-with-doc');

        if ( !accordion.hasClass('_expanded') ) {
            if (collapsible) {
                container.find('.js-accordion-with-doc').removeClass('_expanded');
                accordionBody.stop().slideUp(300);
            }
            accordion.addClass('_expanded');
            accordion.find('.block-with-doc__body').slideDown(300);
        }
        else {
            accordion.removeClass('_expanded');
            accordion.find('.block-with-doc__body').stop().slideUp(300);
        }
    });
}